import {
	type PostPartnersIdRegisterPortalFetchResponse,
	postPartnersIdRegisterPortal,
} from "Infrastructure/Api/Api";
import {
	ApiCallError,
	getMessageFromErrorResponse,
	processResponse,
} from "Infrastructure/Api/ApiUtils";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export const useRegisterPartnerPortal = (partnerId: number) => {
	return useMutation({
		mutationFn: processResponse<
			undefined,
			PostPartnersIdRegisterPortalFetchResponse
		>(() => postPartnersIdRegisterPortal(partnerId)),
		onError: (error) => {
			const message =
				error instanceof ApiCallError
					? getMessageFromErrorResponse(error)
					: error.message;
			toast.error(
				`Failed to register partner in portal: ${message || "Unknown error"}`,
			);
		},
		onSuccess: (response) => {
			if (response.success) {
				toast.success(response.message);
			} else {
				toast.error(response.message);
			}
		},
	});
};
